<template>
  <div>
    <v-row>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-4"
         v-model="editedItem.ownerName" label="Owner Name" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <!-- Rows the June Resale build creates still carry the care-of copied off the tax
             record so the certified mailers keep printing it; the box is just not typeable. -->
        <v-text-field class="input-text-size ma-0 pa-0 mt-4"
         v-model="editedItem.inCareOf" label="In Care of"
         :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
         v-model="editedItem.Address1" label="Address 1" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
         v-model="editedItem.Address2" label="Address 2" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
         v-model="editedItem.Address3" label="Address 3" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
         v-model="editedItem.city" label="City" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
         v-model="editedItem.state" label="State" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          label="Zip" v-model="editedItem.zip"
          @blur="zipFormatter('zip')" :value="formattedValues.zip"
          @focus="(e) => { zipUnformatter(e, 'zip') }" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
         v-model="editedItem.country" label="Country" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
         v-model="editedItem.printCertifiedMailer"
         label="Print Certified Mailer" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { amountFormat, zipDeFormat, zipFormat } from '../../../../../../util/shared/vue-global';
import InCareOfSetting from '../../../../common-utils/inCareOf.mixin';

export default {
  name: 'AdditionalNameAddressesDialog',
  mixins: [InCareOfSetting],
  props: {
    baseCrudKey: {
      type: String,
      default: 'baseCrudKeyAdditionalTable',
    },
  },
  data() {
    return {
      formattedValues: {
        zip: '',
      },
    };
  },
  mounted() {
    this.zipFormatter('zip');
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'criteria',
      'index',
      'isVisible',
    ]),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKeyAdditional);
      },
      set(value) {
        this.setCriteria([this.baseCrudKeyAdditional, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    amountFormat,
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setHighlightedId']),
    zipUnformatter(e, val) {
      const formatedAmt = zipDeFormat(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.formattedValues[val] = formatedAmt;
      // settimout is required to make it select after the zip state is set
      setTimeout(() => e.target.select(), 50);
    },
    zipFormatter(val) {
      const formatedAmt = zipFormat(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.formattedValues[val] = formatedAmt;
    },
  },
};
</script>
